import { use } from 'react';

import { ManagerSessionContext } from '@/features/auth/context/managerSessionContext';
import type { ManagerContext } from '@/features/auth/types/ManagerContext';

export function useManagerSession(): ManagerContext {
  const context = use(ManagerSessionContext);

  if (!context) {
    throw new Error('useManagerSession must be used within ManagerSessionProvider.');
  }

  return context;
}
